<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'

import Card from '../../../../components/ui/Card.vue'
import ContentBody from '../../../../components/ui/ContentBody.vue'
import ContentHeader from '../../../../components/ui/ContentHeader.vue'
import Breadcrumb from '../../../../components/ui/breadcrumb/Breadcrumb.vue'
import Tag from '../../../../components/ui/tag/Tag.vue'
import { RouterLink } from 'vue-router'

const route = useRoute()

const { getCrumbs, children } = useLayoutCrud()

const step = ref(getCrumbs().length - 1)

function useLayoutCrud() {
	const { currentRoute } = useRouter()
	const { name } = currentRoute

	function getCrumbs() {
		const pathArray = (useRouter().currentRoute.meta!.breadcrumb as string)
			.split('/')
			.filter((crumb) => crumb != '')

		return pathArray.map((crumb, index) => {
			return {
				name: crumb,
				step: index,
			}
		})
	}

	const children = computed(() => {
		return [
			{
				name: 'configurações de alerta',
				path: '/fire-risk/alert-settings',
			},
			{ name: 'usuários notificados', path: '/fire-risk/notified-users' },
		]
	})

	return { getCrumbs, children, name }
}
</script>

<template>
	<div class="flex justify-center flex-col">
		<ContentHeader>
			<Breadcrumb
				v-model="step"
				:icon="false"
				:crumbs="getCrumbs()"
				transform="none"
				class="breadcrumb__internal flex justify-start"
			/>
		</ContentHeader>
		<ContentBody>
			<Card class="card">
				<div class="flex gap-4 justify-end">
					<RouterLink
						v-for="child in children"
						:key="child.name"
						:to="child.path"
					>
						<Tag
							class="py-0.5"
							:active="route.name?.toLocaleLowerCase() === child.name.toLocaleLowerCase()"
						>
							{{ child.name }}
						</Tag>
					</RouterLink>
				</div>
				<slot />
			</Card>
		</ContentBody>
	</div>
</template>

<style scoped>
.card {
	@apply px-20 py-8 bg-white w-full;
}

.active {
	@apply border-blue-600;
}
</style>
